import CONFIG from 'Config';
import HttpClient from 'Api/HttpClient';
import HttpClientFile from './HttpClientFile';

export const httpClientCDN = new HttpClient('');
export const httpClientCMS = new HttpClient(CONFIG.urls.cms);
export const httpClientUser = new HttpClient(CONFIG.urls.user);
export const httpClientFarm = new HttpClient(CONFIG.urls.farm);
export const httpClientBlog = new HttpClient(CONFIG.urls.blog);
export const httpClientInvestment = new HttpClient(CONFIG.urls.investment);
export const httpClientMarket = new HttpClient(CONFIG.urls.market);
export const httpClientNotification = new HttpClient(CONFIG.urls.notification);
export const httpClientPlaid = new HttpClient(CONFIG.urls.plaid);
export const httpClientStaticData = new HttpClientFile(CONFIG.staticDataPath);
